/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Audio_Embed_Export_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Audio embed export failed: {error}" |
*
* @param {Audio_Embed_Export_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_failed_toast = /** @type {((inputs: Audio_Embed_Export_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'exportation de l'intégration audio : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audio-Einbettungs-Export fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esportazione dell'incorporamento audio non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка экспорта аудиофайла: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al exportar el audio incrustado: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频嵌入导出失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`音声埋め込みのエクスポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो एम्बेड निर्यात विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na exportação do áudio incorporado: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Audio embed export failed: ${i?.error}`)
});